<i18n src="../../locales/lang.json"></i18n>
<template>
  <div>
    <div class="container-fluid px-0">
      <button type="button" class="btn btn-light" @click="open">
        {{$t('select_html_template')}}
        <i class="fa fa-clipboard ml-2"></i>
      </button>
    </div>
    
    <modal-default v-bind:title="$store.translate('html_templates')" ref="thisModal" v-bind:onsave="doSave" v-bind:buttontext="$t('select_html_template')" size="modal-md mx-4 mx-md-auto">
      <div style="height:75%; overflow-y:auto;" >
        <div class="container-fluid" style="background-color:#f7f7f7">
          <div class="row p-2">
            <div v-bind:id="'card' + template.id" class="card col-3 p-0 mr-2 mr-md-4" v-for="template in templates" @click="selectTemplate(template)" style="float:left; margin-left:10px; border:5px solid white;" v-bind:class="{'border-blue': selectedTemplate != null && template.id == selectedTemplate.id}">
              <div class="card-body p-0">
                <img v-bind:src="template.image" width="100%" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal-default>
  </div>

</template>

<script>
  var selectedTemplate = null;

  let templates = [
    {
      id: 1,
      image: "/images/templates/info.png",
      name: "Information",
      markup: '<div class="information card m-0 shadow-0" style="border-radius:0px"><div class="card-title p-2 pr-3" style="background-color:#DAE7C2"><div class="media"><div class="media-body"><h3 class="text-white m-0">Info</h3></div><div class="ml-3 align-self-center text-white"><!-- icon --></em></div></div></div><p class="card-body ">By using the im build templates it is easy to create content for your users. <br> You can use the important note, discussion och tutorial templates and just modify the content.</p></div>',
    },

    {
      id: 2,
      image: "/images/templates/discuss.png",
      name: "Discuss",
      markup: '<div class="discuss card m-0 shadow-0" style="border-radius:0px"><div class="card-title p-2 pr-3 " style="background-color:#57C2D4"><div class="media"><div class="media-body"><h3 class="text-white m-0">Discuss</h3></div><div class="ml-3 align-self-center text-white"><!-- icon --></em></div></div></div><p class="card-body ">By using the im build templates it is easy to create content for your users. <br> You can use the important note, discussion och tutorial templates and just modify the content.</p></div>',
    },
    {
      id: 3,
      image: "/images/templates/important.png",
      name: "Attention",
      markup: '<div class="attention card m-0 shadow-0" style="border-radius:0px"><div class="card-title p-2 pr-3 attention" style="background-color:#EE7A30"><div class="media"><div class="media-body"><h3 class="text-white m-0">Important</h3></div><div class="ml-3 align-self-center text-white"><!-- icon --></em></div></div></div><p class="card-body ">By using the im build templates it is easy to create content for your users. <br> You can use the important note, discussion och tutorial templates and just modify the content.</p></div>',
    },
    {
      id: 4,
      image: "/images/templates/topimage.png",
      name: "TopImage",
      markup: '<div class="card m-0"><div style="width:100%" class="text-center"><img src="/images/imagemissing_fill_grey.png" class="img-fluid card-img-top" alt=""></div><div class="card-body">Lorem ipsum</div></div>',
   },
    {
      id: 5,
      image: "/images/templates/fullimage.png",
      name: "FullImage",
      markup: '<div class="card m-0"><div style="width:100%" class="text-center"><img src="/images/imagemissing_fill_grey.png" class="img-fluid card-img-top" alt=""></div></div>',
    },
    {
      id: 6,
      image: "/images/templates/rightimage.png",
      name: "RightImage",
      markup: '<div class="card m-0"><div class="card-body"><div class="row"><div class="col-6">Lorem ipsum</div><div class="col-6"><img src="/images/imagemissing_fill_grey.png" class="img-fluid card-img-top" alt=""></div></div></div></div>',
    },
    {
      id: 7,
      image: "/images/templates/movie.png",
      name: "Movie",
      markup: '<div class="card m-0"><div style="width:100%" class="text-center"><iframe src="https://www.youtube.com/embed/D6_DKKyyiiU" allowfullscreen="allowfullscreen" width="560" height="314"></iframe></div><div class="card-body">Lorem ipsum</div></div>',
    },
    {
      id: 8,
      image: "/images/templates/file.png",
      name: "File",
      markup: '<div class="card m-0 shadow-0" style="border-radius:0px"><div class="mceTmpl m-0 card shadow-0 has-bg-image" style="border-radius:0px"><div class="card-body p-2 pr-3" style="background-color:#DAE7C2"><div class="media"><div class="media-body"><h3 class="text-white m-0">Info</h3></div><div class="ml-3 align-self-center text-white"><!-- icon --></em></div></div></div><p class="card-body ">By using the im build templates it is easy to create content for your users. <br> You can use the important note, discussion och tutorial templates and just modify the content.</p><div class="row p-0 m-0"><div class="col-12 pl-3 pb-3"><a href="https://link_to_your_file">Edit this link</a></div></div></div></div>',
    },
  ];

  import ModalDefault from "../modals/modal-default.vue";

  import vuescroll from 'vuescroll';

  export default {
    name: "html-templates",
    components: {
      ModalDefault,
      vuescroll
    },
    props: {

    },
    data() {
      return {
        selectedTemplate,
        templates,
        ops: {
          vuescroll: {
            mode: 'slide',
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            background: '#F6F7F7',
            opacity: 0.5,
            size: '6px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            gutterOfSide: '2px',
            keepShow: false
          },
          bar: {
            onlyShowBarOnScroll: false,
            keepShow: true,
            background: '#666767',
          }
        }
      };
    },
    methods: {
      selectTemplate(template) {
        //alert(JSON.stringify(template))
        this.selectedTemplate = template;
        this.$forceUpdate();
      },
      getId() {
        return this._uid;
      },

      open() {
        this.$refs.thisModal.open();

      },
      async doSave() {
        this.$root.$emit('selected_template', this.selectedTemplate);
        this.$emit('selected_template', this.selectedTemplate);
        this.$refs.thisModal.close();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {

      }
    },
    computed: {
     
    },
    watch: {
      
    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>

  

  .card.border-blue {
    border-color: #03a9f4 !important;
  }
  
  .card:hover {
    box-shadow: 0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/mce/html-templates.vue